import { AppState } from "../../../states";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { ContactTypes } from "../../constants";
import { Chat } from "./Chat";
import { User } from "../../states/WorkspacesState";

export interface StateToProps {
  tеchnician_contacts: any;
  customer_contacts: any;
  contacts: any;
  contactType: number;
  activeContactIndex: number;
  chat: any[];
  chatLoadingIndicator: boolean;
  selectedWorkspace: User | null;
}

export interface DispatchToProps {}

const mapStateToProps = (state: AppState): StateToProps => {
  // @ts-ignore
  const contactType = state["call-center"].messages.contactType;
  const contactsStateType =
    contactType === ContactTypes.TECHNICIAN
      ? "cmnc_tech_contacts"
      : "cmnc_cust_contacts";

  return {
    // @ts-ignore
    tеchnician_contacts: state["call-center"].cmnc_tech_contacts.contacts,
    // @ts-ignore
    customer_contacts: state["call-center"].cmnc_cust_contacts.contacts,
    // @ts-ignore
    contactType: contactType,

    // @ts-ignore
    contacts: state["call-center"][contactsStateType].contacts,
    activeContactIndex:
      // @ts-ignore
      state["call-center"][contactsStateType].activeContactIndex,

    // @ts-ignore
    chat: state["call-center"][contactsStateType].chat,
    chatLoadingIndicator:
      // @ts-ignore
      state["call-center"][contactsStateType].chatLoadingIndicator,
    // @ts-ignore
    selectedWorkspace: state["call-center"].cmnc_users.selectedWorkspace,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchToProps => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
